/**=========================================================
 * Module: title.js
 * Title Controller
 =========================================================*/

 App.controller('TitleController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster) {
   "use strict";

   let updateTitle = function(){
    if($scope.page){
      var title = $filter('translate')($scope.page.title, $scope.page.titleParams);
      var subTitle = $filter('translate')($scope.page.subTitle, $scope.page.subTitleParams);
      $('title').text('Aqrate / ' + title + (subTitle ? ' - ' + subTitle : ''));
      if(title){
        $rootScope.gaTitle = $('title').text();
        $rootScope.$broadcast('$titleChange');
      }
    } else {
      $('title').text('Aqrate');
    }
  }

  let unwatch = $scope.$watch('page.title', updateTitle);
  let unwatchSub = $scope.$watch('page.subTitle', updateTitle);

  $scope.$on('$destroy', function(){
    unwatch();
    unwatchSub();
  });

 }]);